/*------------------------------------*\
	#EVERYONE ENERGY
\*------------------------------------*/

const everyoneEnergyIframe = document.querySelector(".js-everyone-energy-iframe");

window.addEventListener('message', event => {
	if (everyoneEnergyIframe) {
		everyoneEnergyIframe.style.height = event.data.height + 'px';
	}
}, false);
